if (document.querySelector('.gallerySlider_photos')) {
    let nextButtons = document.querySelectorAll('.gallerySlider_nextBtn');
    let prevButtons = document.querySelectorAll('.gallerySlider_prevBtn');

    let photoTrack = document.querySelectorAll('.gallerySlider_photos');

    window.addEventListener('load', () => {
        photoTrack.forEach(track => {
            track.classList.remove('flex');
            track.classList.remove('flex-col')
            track.classList.add('gallerySlider_photos-container');
            track.scrollBy({left: -1000000, behavior: 'smooth'})
            track.parentNode.querySelector('.gallerySlider_nextBtn').classList.remove('hidden')
        })
    })


    nextButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            let amountToScroll = getSliderWidth();
            let photoTrack = btn.parentNode.parentNode.querySelector('.gallerySlider_photos-container');
            photoTrack.scrollBy({left: amountToScroll, behavior: 'smooth'});

            let prevButton = btn.parentNode.querySelector('.gallerySlider_prevBtn');
            prevButton.classList.remove('hidden')

            if (photoTrack.scrollWidth - (amountToScroll + photoTrack.scrollLeft) == amountToScroll || photoTrack.scrollWidth - (amountToScroll + photoTrack.scrollLeft) == 0) {
                btn.classList.add('hidden');
            }


   
            
        })
    })

    prevButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            let amountToScroll = getSliderWidth() * -1;
            let photoTrack = btn.parentNode.parentNode.querySelector('.gallerySlider_photos-container');
            photoTrack.scrollBy({left: amountToScroll, behavior: 'smooth'});


            let nextButton = btn.parentNode.querySelector('.gallerySlider_nextBtn');
            nextButton.classList.remove('hidden')

            if (photoTrack.scrollLeft <= (amountToScroll*-1)) {
                btn.classList.add('hidden');
            }

        })


    })

    function getSliderWidth() {
        let sliderWidth = document.querySelector('.gallerySlider_photos-container').offsetWidth; 
        return sliderWidth;
    }

}
